import React, { useEffect, useState } from 'react';
import EditFormDialog from '../../../../shared/components/EditFormDialog';
import { FileText } from '../../../../shared/assets/AppIcons';
import { PartyField } from '../../../../shared/components/PartyFormFields';
import { entitySelectionPayload } from '../../../../shared/utils/entitySelection';
import { entityLabel } from '../../../../shared/components/EntityMultiSelect';
import { listClientsResult } from '../../../clients/services/clients.service';
import InvoiceForm from './InvoiceForm';
import PaymentFormFields from './PaymentFormFields';
import AccountingCommentsSection from '../shared/AccountingCommentsSection';
import { getPaymentStatusMeta } from '../../utils';

export default function EditIncomeDialog({ open, mode, source, payments, onClose, onSave }) {
  const [clients, setClients] = useState([]);
  const [catalogError, setCatalogError] = useState('');
  useEffect(() => {
    let active = true;
    listClientsResult().then(result => { if (active) { setClients(result.ok ? result.data || [] : []); setCatalogError(result.ok ? '' : result.message || 'Catalogo clienti non disponibile.'); } })
      .catch(() => { if (active) setCatalogError('Catalogo clienti non disponibile.'); });
    return () => { active = false; };
  }, []);
  const isInvoice = mode === 'invoice';
  const linked = Boolean(source.invoiceId || source.completedDealId || source.inProgressDealId);
  const initial = { ...source, ...entitySelectionPayload(source),
    amount: String(source.amount ?? ''), assignment: source.assignment || source.invoiceNumber || '',
    client: source.client || source.clientResolvedName || '', issueDate: source.issueDate || '',
    reason: source.reason || '', notes: source.notes || '', dueDate: source.dueDate || '', paymentDate: source.paymentDate || '',
    paymentExpectedDate: source.paymentExpectedDate || payments[0]?.dueDate || '',
    type: source.type || (payments.length > 1 ? 'rateizzato' : 'unico'), customFields: { ...(source.customFields || {}) },
  };
  return <EditFormDialog open={open} title={isInvoice ? 'Modifica fattura' : 'Modifica incasso'} icon={FileText}
    initialValue={initial} onSave={onSave} onClose={onClose} className="accounting-form-dialog" formClassName="party-form"
    saveLabel={isInvoice ? 'Salva fattura' : 'Salva incasso'}
    comments={<AccountingCommentsSection entityType={isInvoice ? 'invoice' : 'payment'} entityId={source.id} />}>
    {({ value, onFieldChange, saving }) => {
      const selectClients = ids => {
        onFieldChange('clientIds', ids); onFieldChange('clientId', ids[0] || '');
        onFieldChange('client', ids.map(id => entityLabel(clients.find(item => String(item.id) === String(id)))).join('; '));
      };
      return <>
        {catalogError && <p role="alert" className="wt-inline-error">{catalogError}</p>}
        {isInvoice ? <InvoiceForm fieldsOnly readOnlyPlan form={value} clients={clients} isSubmitting={saving}
          installments={payments} renderActions={false} enableCustomFields onFieldChange={onFieldChange}
          onClientChange={id => onFieldChange('client', entityLabel(clients.find(item => String(item.id) === String(id))))} /> : <>
          <PaymentFormFields editing linked={linked} form={value} clients={clients} isSubmitting={saving}
            titleField="assignment" dateField={value.status === 'incassato' ? 'paymentDate' : 'dueDate'} update={onFieldChange} selectClients={selectClients} />
          <div className="party-form__row">
            <div className="party-form__field"><label htmlFor="payment-status">Stato</label>
              <select id="payment-status" disabled={saving || ['stornato', 'annullato'].includes(source.status)} value={value.status}
                onChange={event => onFieldChange('status', event.target.value)}>
                {['stornato', 'annullato'].includes(source.status) && <option value={source.status}>{getPaymentStatusMeta(source.status).label}</option>}
                <option value="previsto">Da incassare</option><option value="in_ritardo">In ritardo</option><option value="incassato">Incassato</option>
              </select>
            </div>
            {value.status === 'incassato' && <PartyField id="payment-due-date" label="Scadenza" type="date" required value={value.dueDate}
              onChange={next => onFieldChange('dueDate', next)} disabled={saving} />}
          </div>
        </>}
      </>;
    }}
  </EditFormDialog>;
}
